import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLACK } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const Track22BBlack = ({ state, workState, onLabelClick }) => (
	<g id="Track22BBlack" transform="translate(2070.000000, 1207.000000)" className="track">
		<path
			d="M0,212.15625 L54.8216674,159.78563 C60.7157169,154.155101 69.3546509,152.484637 76.922839,155.512047 C84.5986234,158.582497 93.3335118,157.276716 99.7757889,152.095751 L151.278231,110.676802 C159.049033,104.42742 165.841379,97.0508693 171.429833,88.791976 L189.431763,62.1878362 M195.58287,52.2368964 L231.511719,0"
			stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
			strokeWidth={tracksWidth}
			strokeLinecap="round"/>

		<TrackArrow
			transform="translate(196.437589, 50.786612) rotate(-56.000000) translate(-196.437589, -50.786612) "
			points="200.437589 58.7866123 192.437589 50.7866123 200.437589 42.7866123"
			strokeColor={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track22BBlack')}
			coords="145.000000, 80.250000"
			text="22B"
			textCoordsX="7.12841797"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLACK)}
		/>
	</g>
);

Track22BBlack.propTypes = trackPropTypes;

export default Track22BBlack;
